import { render, staticRenderFns } from "./ToolsBar.vue?vue&type=template&id=35355c25&scoped=true"
import script from "./ToolsBar.vue?vue&type=script&lang=js"
export * from "./ToolsBar.vue?vue&type=script&lang=js"
import style0 from "./ToolsBar.vue?vue&type=style&index=0&id=35355c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35355c25",
  null
  
)

export default component.exports